import { OrcaVOD } from "../../components/src/video/orca/OrcaVOD";
import { firstLineExecution } from "./firstLineExecution";

firstLineExecution();
export default OrcaVOD;
